module.exports = __webpack_public_path__ + "img/agility_test.8eecd281.jpg";